import { Module } from 'vuex';
import { CsvListState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: CsvListState = {
    lists: undefined,
    count: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    download: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const csv: Module<CsvListState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
